import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faKey,
  faPencil,
  faUserSlash,
  faUserPlus,
  faLock,
  faToggleOn,
  faToggleOff,
  faPhone,
  faPhoneSlash,
  faDownload,
  faMagicWandSparkles
} from '@fortawesome/free-solid-svg-icons';
import {
  getRecentLogs,
  getRecentLogsCalling,
  AccountLog
} from '../services/accountlog.service';

export interface ActivityTimelineData {
  id: number;
  oppositeContent: {
    date: string;
    time: string;
  };
  content: {
    title: string;
    username: string;
    description: string;
  };
  separator: {
    icon: IconProp;
  };
}

const formatLogData = (logs: AccountLog[]): ActivityTimelineData[] => {
  return logs.map(log => {
    const logDate = new Date(log.logdate);

    let icon = faPencil; // default icon

    if (log.title.toLowerCase().includes('login')) {
      icon = faKey;
    } else if (log.title.toLowerCase().includes('created')) {
      icon = faUserPlus;
    } else if (log.title.toLowerCase().includes('deleted')) {
      icon = faUserSlash;
    } else if (log.title.toLowerCase().includes('password')) {
      icon = faLock;
    } else if (log.title.toLowerCase().includes('open')) {
      icon = faToggleOn;
    } else if (log.title.toLowerCase().includes('pause')) {
      icon = faToggleOff;
    } else if (log.title.toLowerCase().includes('unblock')) {
      icon = faPhone;
    } else if (log.title.toLowerCase().includes('block')) {
      icon = faPhoneSlash;
    } else if (log.title.toLowerCase().includes('downloaded')) {
      icon = faDownload;
    } else if (log.title.toLowerCase().includes('qa call processor')) {
      icon = faMagicWandSparkles;
    }

    return {
      id: log.id,
      oppositeContent: {
        date: logDate.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        }),
        time: logDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit'
        })
      },
      content: {
        title: log.title,
        username: `${log.account.name} ${log.account.lastname}`,
        description: log.description
      },
      separator: {
        icon: icon
      }
    };
  });
};

export const fetchActivityTimelineData = async (): Promise<
  ActivityTimelineData[]
> => {
  try {
    const logs = await getRecentLogs();
    return formatLogData(logs);
  } catch (error) {
    console.error('Error fetching activity timeline data:', error);
    throw error;
  }
};

export const fetchActivityCallingTimelineData = async (): Promise<
  ActivityTimelineData[]
> => {
  try {
    const logs = await getRecentLogsCalling();
    return formatLogData(logs);
  } catch (error) {
    console.error('Error fetching activity timeline data:', error);
    throw error;
  }
};
